export const ENV_MODE_DEV = process.env.NODE_ENV === 'development';
export const ENV_MODE_PROD = process.env.NODE_ENV === 'production';
export const ENV_MODE_TEST = process.env.NODE_ENV === 'test';

// const apiConfig = window.globalConfig;

// const BASE_API_URL = process.env.REACT_APP_API_URL;

/**
 * Default (Live & Local)
 * 개발 서버 빌드 시 주석처리
 */
// export const BASE_API_URL = ENV_MODE_PROD
//   ? process.env.REACT_APP_BASE_API_URL
//   : process.env.REACT_APP_BASE_API_LOCAL_URL;

// export const BASE_BIN_URL = ENV_MODE_PROD
//   ? `${process.env.REACT_APP_BASE_BIN_URL}/bin/v1`
//   : `${process.env.REACT_APP_BASE_BIN_LOCAL_URL}/bin/v1`;

// export const BASE_SOCKET_PRIVATE_URL = ENV_MODE_PROD
//   ? `${process.env.REACT_APP_BASE_SOCKET_URL}/private`
//   : `${process.env.REACT_APP_BASE_SOCKET_LOCAL_URL}/private`;

// export const BASE_SOCKET_PROJECT_URL = ENV_MODE_PROD
//   ? `${process.env.REACT_APP_BASE_SOCKET_URL}/project`
//   : `${process.env.REACT_APP_BASE_SOCKET_LOCAL_URL}/project`;

// export const BASE_AUTH_URL = ENV_MODE_PROD
//   ? process.env.REACT_APP_AUTH_URL
//   : process.env.REACT_APP_AUTH_LOCAL_URL;

/**
 * Dev Server Build
 * 개발 서버 빌드 시 주석해제
 */
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

export const BASE_BIN_URL = `${process.env.REACT_APP_BASE_BIN_URL}/bin/v1`;

export const BASE_SOCKET_PRIVATE_URL = `${process.env.REACT_APP_BASE_SOCKET_URL}/private`;

export const BASE_SOCKET_PROJECT_URL = `${process.env.REACT_APP_BASE_SOCKET_URL}/project`;

export const BASE_AUTH_URL = process.env.REACT_APP_AUTH_URL;

/**
 * Field TEST Server Build
 * 필드 테스트 빌드 시 주석해제
 */

// export const BASE_API_URL = process.env.REACT_APP_BASE_API_FIELD_URL;

// export const BASE_BIN_URL = `${process.env.REACT_APP_BASE_BIN_LOCAL_URL}/bin/v1`;

// export const BASE_SOCKET_PRIVATE_URL = `${process.env.REACT_APP_BASE_SOCKET_FIELD_URL}/private`;

// export const BASE_SOCKET_PROJECT_URL = `${process.env.REACT_APP_BASE_SOCKET_FIELD_URL}/project`;

// export const BASE_AUTH_URL = process.env.REACT_APP_AUTH_FIELD_URL;

/**
 * 라이브 전용
 */

// export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

// export const BASE_BIN_URL = `${process.env.REACT_APP_BASE_BIN_URL}/bin/v1`;

// export const BASE_SOCKET_PRIVATE_URL = `${process.env.REACT_APP_BASE_SOCKET_URL}/private`;

// export const BASE_SOCKET_PROJECT_URL = `${process.env.REACT_APP_BASE_SOCKET_URL}/project`;

// export const BASE_AUTH_URL = process.env.REACT_APP_AUTH_URL;
